<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-filters">
        <div class="filter-list">
          <div class="filter-item">
            <span class="title">Name:</span>
            <el-input class="content" placeholder="Search by name" v-model="filter.name" size="small" clearable @change="changeFilter"></el-input>
          </div>
          <!-- <div class="filter-item">
            <span class="title">Status: </span>
            <el-select class="content" size="small" v-model="filter.status" placeholder="Search by status" @change="changeFilter">
              <el-option key="0" label="All" value=""></el-option>
              <el-option key="1" label="Active" value="1"></el-option>
              <el-option key="2" label="Pending" value="0"></el-option>
            </el-select>
          </div> -->
        </div>
        <div class="filter-actions">
          <el-button class="el-btn-blue" size="small" @click="changeFilter">Search</el-button>
          <el-button class="action-reset" size="small" @click="resetFilter">Reset</el-button>
        </div>
      </div>
      <div class="main-actions">
        <el-button class="el-btn-blue" size="small" icon="el-icon-plus" @click="newProduct()">New Instance</el-button>
      </div>
      <div class="main-table">
        <el-table :data="instances" v-loading="flagLoading.getInstances" border>
          <el-table-column type="index" label="#" :index="generateIndex" width="100" />
          <el-table-column prop="general.name" label="Instance" />
          <!-- <el-table-column label="Status">
            <template #default="scope">
              <span>{{ generateStatus(scope.row.general.is_published) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="Last updated">
            <template #default="scope">
              <span>{{ generateTime(scope.row.updated_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Operate">
            <template #default="scope">
              <el-button type="text" @click="editInstance(scope.row)">Edit</el-button>
              <el-button type="text" v-loading="flagLoading.syncProducts" @click="syncProducts(scope.row)">Sync Products</el-button>
              <!-- <el-button type="text" @click="previewInstance(scope.row)">Preview</el-button> -->
              <!-- <el-popconfirm
                title="Sure to duplicate this instance?"
                @confirm="duplicateInstance(scope.row)"
              >
                <template #reference>
                  <el-button type="text">Duplicate</el-button>
                </template>
              </el-popconfirm> -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="common-pagination" background layout="prev, pager, next"
          :current-page="pageNum" :page-size="pageSize" :total="totalNum"
          @current-change="changeCurrentPage"
        />
      </div>
    </div>
    <ModalInstance
      :actionItem="actionItems.instance" :flagVisible="flagVisible.modalInstance"
      @closeModal="flagVisible.modalInstance = false" @reloadData="reloadData"
    />
    <atk-player-staging />
  </div>
</template>

<script>
import { reactive } from 'vue'
import moment from 'moment'
import ModalInstance from '@/components/modals/atk/instances/New.vue'
export default {
  name: 'AtkMobileInstances',
  components: {
    ModalInstance,
    'atk-player-staging': 'atk-player-staging'
  },
  data () {
    const filter = reactive({
      name: '',
      status: ''
    })
    const flagLoading = reactive({
      getInstances: false,
      duplicateInstance: false,
      syncProducts: false
    })
    const flagVisible = reactive({
      modalInstance: false
    })
    const actionItems = reactive({
      instance: { _id: '' }
    })
    return {
      instances: [],
      pageNum: 1,
      pageSize: 20,
      totalNum: 0,
      filter,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created () {
    this.getInstances()
  },
  mounted () {
  },
  computed: {
    userInfo: function () {
      return this.$store.getters.userInfo
    }
  },
  watch: {
  },
  methods: {
    getInstances: function () {
      this.flagLoading.getInstances = true
      const { pageNum, pageSize, filter } = this
      let url = `/api/v1/atk/mobile/instances?page_num=${pageNum}&page_size=${pageSize}`
      if (filter.name) url += `&name=${filter.name}`
      if (filter.status) url += `&is_published=${filter.status === '1' ? 'true' : 'false'}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.instances = res.data.list
          that.totalNum = res.data.total_num
        }
        that.flagLoading.getInstances = false
      }).catch(function (err) {
        console.error('getInstances', err)
        that.flagLoading.getInstances = false
      })
    },
    generateTime: function (time) {
      const tz = moment().utcOffset()
      return moment(time).utcOffset(tz).format('D MMM YYYY HH:mm')
    },
    generateStatus: function (published) {
      let str = ''
      switch (`${published}`) {
        case '1':
          str = 'Active'
          break
        case '0':
          str = 'Pending'
          break
      }
      return str
    },
    changeCurrentPage: function (page) {
      this.pageNum = page
      this.getInstances()
    },
    changeFilter: function () {
      this.pageNum = 1
      this.getInstances()
    },
    resetFilter: function () {
      this.filter = { name: '', status: '' }
      this.pageNum = 1
      this.getInstances()
    },
    generateIndex: function (index) {
      const { pageNum, pageSize } = this
      return index + 1 + pageSize * (pageNum - 1)
    },
    newProduct: function () {
      const actionInstance = this.actionItems.instance
      if (actionInstance._id) {
        this.actionItems.instance = { _id: '', general: { is_published: 0 } }
      }
      this.flagVisible.modalInstance = true
    },
    editInstance: function (instance) {
      this.$router.push({ path: `/atk/instances/${instance._id}/edit` })
    },
    syncProducts: function (instance) {
      this.flagLoading.syncProducts = true
      const url = '/api/v1/admin/mobile_instances/sync_products'
      const that = this
      const body = { instance_id: instance._id }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: res.msg })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.syncProducts = false
      }).catch(function (err) {
        console.error('syncProducts', err)
        that.$message({ type: 'error', message: err })
        that.flagLoading.syncProducts = false
      })
    },
    reloadData: function () {
      this.actionItems.instance = { _id: '' }
      this.getInstances()
    },
    previewInstance: function (instance) {
      document.querySelector('atk-player-staging').params = { status: 'show', instance: instance._id }
    },
    duplicateInstance: function (instance) {
      if (this.flagLoading.duplicateInstance) return
      this.flagLoading.duplicateInstance = true
      const url = '/api/v1/atk_player/instances/copy'
      const that = this
      this.$service.post(url, { id: instance._id }).then(function (res) {
        if (res.code === 200) {
          that.getInstances()
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.duplicateInstance = false
      }).catch(function (err) {
        console.error('duplicateInstance', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.duplicateInstance = false
      })
    }
  }
}
</script>
